import { Component } from '@angular/core';
import {PublicReportsReportStore} from '../../../store/publicReports/public-reports-report.store';
import {Observable} from 'rxjs';
import {FullscreenService} from '../../../services/fullscreen.service';

@Component({
  selector: 'app-report-info-button',
  templateUrl: './report-info-button.component.html',
  styleUrls: ['./report-info-button.component.scss']
})
export class ReportInfoButtonComponent {
  public readonly drawerIsOpened$: Observable<boolean> = this._publicReportsReportStore.drawerIsOpened$;
  public readonly fullscreen$: Observable<boolean> = this._fullscreenService.onFullscreen$;

  constructor(
    private readonly _publicReportsReportStore: PublicReportsReportStore,
    private readonly _fullscreenService: FullscreenService
  ) {}

  public onOpenDrawer(): void {
    this._publicReportsReportStore.openDrawer();
  }

  protected readonly open = open;
}
